
<form [formGroup]="formGroup">
    <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="search" placeholder="Inserisci il codice" formControlName="search"/>
        <p-button icon="pi pi-search" [disabled]="formGroup.invalid" styleClass="p-button-warn" (onClick)="validateExternalCode()"></p-button>
        <p-button icon="pi pi-camera" styleClass="p-button-warn" (onClick)="toggleScan()"></p-button>
    </div>
</form>
<div class="mt-2">
    <ngx-scanner-qrcode style="width: 386px; height: 180px !important;" [isBeep]="false"  *ngIf="isScannerActive" #action="scanner"></ngx-scanner-qrcode>
</div>
<div *ngIf="devices.length > 1 && (isScannerActive)" class="mt-2">
    <p-listbox [options]="devices" [style]="{'min-width': '17rem'}" [multiple]="false" [(ngModel)]="selectedDevice" (ngModelChange)="selectedDevice = $event; scanner.playDevice(selectedDevice!.deviceId)"></p-listbox>
</div>
<ng-container *ngIf="searchDone">
    <div class="mt-3">
        <ng-container *ngIf="isValid; else notValid">
            <p-tag severity="success">Utente valido</p-tag>
        </ng-container>
        <ng-template #notValid>
            <p-tag severity="danger">Utente non valido</p-tag>
        </ng-template>
    </div>
</ng-container>
<ng-container *ngIf="user">
    <div class="mt-3">
        <h2 class="m-0">{{user.name}} {{user.lastName}}</h2>
    </div>
</ng-container>